<template>
  <div>
    <select v-model="selectedCurrency" @change="handleCurrencyChange" class="p-3 py-2"
      :disabled="!exchangeRatesAvailable">
      <option value="EUR">€ EUR</option>
      <option v-if="exchangeRatesAvailable" value="USD">$ USD</option>
      <option v-if="exchangeRatesAvailable" value="INR">₹ INR</option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      selectedCurrency: "EUR", // Always default to EUR
      previousCurrency: "EUR",
      tempCurrency: "EUR",
    };
  },
  computed: {
    ...mapGetters({
      exchangeRates: "services/exchangeRates",
      currentCurrency: "services/currentCurrency"
    }),
    exchangeRatesAvailable() {
      console.log(this.exchangeRates)
      return this.exchangeRates && Object.keys(this.exchangeRates).length > 1;
    }
  },
  methods: {
    ...mapActions({ updateExchangeRates: "services/updateExchangeRates" }),
    updateCurrency() {
      // Always allow EUR, check others only if rates available
      if (this.selectedCurrency === "EUR" ||
        (this.exchangeRates && this.exchangeRates[this.selectedCurrency])) {
        this.$store.commit(
          "services/updateCurrentCurrency",
          this.selectedCurrency
        );
        localStorage.setItem("selectedCurrency", this.selectedCurrency);
        this.tempCurrency = this.selectedCurrency;
      } else {
        console.error(
          `Exchange rate for ${this.selectedCurrency} is not available`
        );
        // Fallback to EUR if rates not available
        this.selectedCurrency = "EUR";
        this.updateCurrency();
      }
    },
    handleCurrencyChange() {
      this.previousCurrency = this.selectedCurrency;
      this.updateCurrency();
    },
    initializeCurrency() {
      // Get stored currency, but fallback to EUR if rates not available
      const storedCurrency = localStorage.getItem("selectedCurrency");
      if (storedCurrency === "EUR" ||
        (storedCurrency && this.exchangeRatesAvailable && this.exchangeRates[storedCurrency])) {
        this.selectedCurrency = storedCurrency;
      } else {
        this.selectedCurrency = "EUR";
        localStorage.setItem("selectedCurrency", "EUR");
      }
      this.tempCurrency = this.selectedCurrency;
      this.updateCurrency();
    }
  },
  async mounted() {
    // Set EUR as default immediately
    this.$store.commit("services/updateCurrentCurrency", "EUR");

    // Try to fetch exchange rates
    await this.updateExchangeRates();

    // Initialize currency after rates are fetched (or failed)
    this.initializeCurrency();
  },
  watch: {
    exchangeRates(newValue) {
      if (newValue && Object.keys(newValue).length > 1) {
        // Rates are now available, re-initialize if needed
        this.initializeCurrency();
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 500px;
  max-width: 90%;
}

.modal-content h2 {
  margin-top: 0;
}

.modal-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.modal-content li {
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.modal-content li:last-child {
  border-bottom: none;
}
</style>